import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { App } from './app/App';
import { seedIfEmpty } from './data/seed';
import { store } from './store/store';
import './styles/global.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('无法找到 React 根节点');
}

void seedIfEmpty().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
      </Provider>
    </StrictMode>,
  );
});
